// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-F":"F_delta-pro-ultra-F__o0cnF"};